import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=548a31fe&scoped=true"
import script from "./accountSetting.vue?vue&type=script&lang=js"
export * from "./accountSetting.vue?vue&type=script&lang=js"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=548a31fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548a31fe",
  null
  
)

export default component.exports